<template>
	<div class="edit-row edit-row--b-top">
		<div class="edit-row__label">{{ t('quickEditBar.visibilityFrom')}}</div>
		<field-select
			:label="t('sidebar.visibility.label.first').toLowerCase()"
			:label-inline="true"
			:label-classname="'mr--39'"
			:select-classname="'field--w-38'"
			:class="'mod--edit-bar mode--label-w-normal'"
			:options="zoomLevels"
			:options-available="zoomAvailableLevelsFirstLayer"
			v-model:selected="visibility.min"
		></field-select>
		<field-select
			:label="t('sidebar.visibility.label.last').toLowerCase()"
			:label-inline="true"
			:label-classname="'mr--39'"
			:select-classname="'field--w-38'"
			:class="'mod--edit-bar mode--label-w-normal'"
			:options="zoomLevels"
			:options-available="zoomAvailableLevelsLastLayer"
			v-model:selected="visibility.max"
		></field-select>
	</div>
</template>

<script>
import FieldSelect from '@/components/fields/FieldSelect';
import {computed, reactive} from 'vue';
import {useI18n} from 'vue-i18n';
import {useStore} from 'vuex';
import MapUtils from '@/services/canvas/map-area/MapUtils';
import VisibilityUtils from '@/services/canvas/utils/VisibilityUtils';

export default {
	components: {
		FieldSelect
	},
	props: {
		blocked: {
			type: Boolean,
			default: false
		}
	},
	setup() {
		const {t} = useI18n();
		const store = useStore();
		const { getZoomLevelOptions } = MapUtils();
		const { convertVisibilityToOriginalProperty } = VisibilityUtils();
		const currentEdge = computed(() => store.getters['edges/getSelectedEdge']);
		
		const nodes = computed(() => store.getters["nodes/getNodes"]);
		const nodeFrom = computed(() => nodes.value.find(node => node.id === currentEdge.value.fromNodeId));
		const nodeTo = computed(() => nodes.value.find(node => node.id === currentEdge.value.toNodeId));
		
		// edges visibility cannot be less or more than lowest/highest visibility of its related node
		const edgeAvailableVisibility = computed(() => {
			return {
				visibilityMin: Math.max(nodeFrom.value.visibilityMin, nodeTo.value.visibilityMin),
				visibilityMax: Math.min(nodeFrom.value.visibilityMax, nodeTo.value.visibilityMax)
			}
		});
		// calc available levels of first layer(visibilityMin) depends on value of edge visibilityMax value
		const zoomAvailableLevelsFirstLayer = computed(()=>
			getZoomLevelOptions(Math.min(edgeAvailableVisibility.value.visibilityMax, edgeVisibilityMax.value), edgeAvailableVisibility.value.visibilityMin)
		);
		// calc available levels of last layer(visibilityMax) depends on value of edge visibilityMin value
		const zoomAvailableLevelsLastLayer = computed(()=>
			getZoomLevelOptions(edgeAvailableVisibility.value.visibilityMax, Math.max(edgeVisibilityMin.value, edgeAvailableVisibility.value.visibilityMin))
		);
		
		const edgeVisibilityMin = computed({
			get(){return currentEdge.value.visibilityMin},
			set(value){
				const visibilityData = {
					id: currentEdge.value.id,
					visibility: {
						visibilityMin: value,
						visibilityMax: currentEdge.value.visibilityMax
					}
				}
				edgeVisibilityUpdate(visibilityData);
				edgeVisibilitySave(visibilityData);
			}
		})
		const edgeVisibilityMax = computed({
			get(){return currentEdge.value.visibilityMax},
			set(value){
				const visibilityData = {
					id: currentEdge.value.id,
					visibility: {
						visibilityMin: currentEdge.value.visibilityMin,
						visibilityMax: value
					}
				}
				edgeVisibilityUpdate(visibilityData);
				edgeVisibilitySave(visibilityData);
			}
		})
		
		const visibility = reactive({
			min: edgeVisibilityMin,
			max: edgeVisibilityMax,
		});
		
		const layersAmount = computed(() => store.getters["layers/getLayersAmount"]);
		const zoomLevels = computed(() => getZoomLevelOptions(layersAmount.value))
		
		// ACTIONS
		function edgeVisibilityUpdate(edgeData){
			store.dispatch('edges/visibility/edgeVisibilityUpdate', [edgeData]);
		}
		function edgeVisibilitySave(edgeData){
			store.dispatch('edges/visibility/edgeVisibilitySave', [edgeData]);
		}
		
		return {
			t,
			visibility,
			zoomAvailableLevelsFirstLayer,
			zoomAvailableLevelsLastLayer,
			zoomLevels
		}
	}
}
</script>

<style lang="scss">

</style>
